import { useCallback } from 'react';
import uuid from 'react-uuid';
import { api } from 'src/constants/apiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';
import { convertDate } from 'src/utils/transformation';

interface PoDocumentResponseObject {
  documentId: number;
  documentNumber: string;
  documentType: string;
  documentQuantity: number;
  documentTotal: number;
  status: string;
  statusDate: string;
  linkedDocumentId: string | null;
  linkedDocumentName: string | null;
  canCancel: boolean;
}

export type PoDocumentResponse = PoDocumentResponseObject[];

export interface PoDocumentObject extends Omit<PoDocumentResponseObject, 'statusDate'> {
  statusDate: Date;
  rowId: string;
  selected: boolean;
  poId: string;
  buyerId?: string;
}

export type PoDocuments = PoDocumentObject[];

const usePoDocuments = (poId: string) => {
  const call = useCallback(
    () =>
      new Promise<PoDocuments>((resolve, reject) => {
        if (poId !== undefined && poId) {
          axiosInstance
            .get<PoDocumentResponse>(api.getPoDocument(poId))
            .then((data) => {
              resolve(
                data?.data?.map((item) => ({
                  ...item,
                  documentTotal: item?.documentType === 'Receipt' ? -1 : item?.documentTotal,
                  statusDate: convertDate(item.statusDate),
                  rowId: uuid(),
                  selected: false,
                  poId,
                }))
              );
            })
            .catch((error) => {
              reject(error);
            });
        }
      }),
    [poId]
  );

  const { isLoading, value, setValue, execute } = useAsync(call, true, undefined, []);

  return { isLoading, poDocuments: value, setPoDocuments: setValue, refresh: execute };
};

export default usePoDocuments;
